import { useSelector } from "react-redux";

export const useReportedMedia = () => {
    return useSelector((state) => {
        return state.reports?.data || [];
    });
}